'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

/**
 * Invisible component — ensures ?ref=CODE is captured as the ff_referrer cookie.
 * Middleware sets it server-side; this handles client-side navigation.
 * At signup, AuthContext reads the cookie and writes referred_by to the database.
 * Must be wrapped in <Suspense> in layout (useSearchParams requirement).
 */
export default function ReferralCapture() {
  const params = useSearchParams()

  useEffect(() => {
    const urlRef = params.get('ref')
    if (urlRef && /^[a-f0-9]{8}$/i.test(urlRef)) {
      document.cookie = `ff_referrer=${urlRef}; max-age=${30 * 24 * 60 * 60}; path=/; samesite=lax`
    }
  }, [params])

  return null
}
